import React, { useState } from 'react';
import logo from '../../Images/logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, fas, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import Service from '../servicesSection/Service';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';
import { useStateValue } from '../../State/StateProvider';

function Nav() {
    const [navbar, setNavbar] = useState(false);
    const [showLinks, setShowLinks] = useState(false);
    const [{ basket, user }, dispatch] = useStateValue();

    const changeBackground = () => {
        if (window.scrollY > 100) {
            setNavbar(true)
        } else {
            setNavbar(false)
        }
        // console.log(window.scrollY)
    }

    window.addEventListener('scroll', changeBackground);

    return (
        <nav className={navbar ? 'nav active' : 'nav'}>
            <div className="nav__image">
                {/* <Link to="/" activeClassName="logo__link" exact={true}><img src={logo} alt="logo" /></Link> */}
                <Link to="/" activeClassName="logo__link" exact={true}><h2>Nezox</h2></Link>
            </div>
            <div className="nav__links">
                <ul className="web">

                    <li><Link to="/" exact={true} activeClassName="active__link">Home</Link></li>


                    <li><Link to="/services" activeClassName="active__link">Services</Link></li>


                    <li><Link to="/hardware" activeClassName="active__link">Hardware</Link></li>


                    <li><Link to="/software" activeClassName="active__link">Software</Link></li>


                    <li><Link to="/aboutus" activeClassName="active__link">About Us</Link></li>


                    <li><Link to="/contactus" activeClassName="active__link">Contact Us</Link></li>

                    <li><Link className="cart__item" to="/cart" activeClassName="active__link">
                        <FontAwesomeIcon
                            icon={faShoppingCart}
                        />
                        <span>{basket.length}</span>
                    </Link></li>

                </ul>

                <ul className={showLinks ? "show__mobileLinks hidden" : "hidden"} >

                    <li><Link to="/" exact={true} activeClassName="active__link" onClick={() => setShowLinks(!showLinks)}>Home</Link></li>


                    <li><Link to="/services" activeClassName="active__link" onClick={() => setShowLinks(!showLinks)} > Services</Link></li>


                    <li><Link to="/hardware" activeClassName="active__link" onClick={() => setShowLinks(!showLinks)} > Hardware</Link></li>


                    <li><Link to="/software" activeClassName="active__link" onClick={() => setShowLinks(!showLinks)} > Software</Link></li>


                    <li><Link to="/aboutus" activeClassName="active__link" onClick={() => setShowLinks(!showLinks)} > About Us</Link></li>


                    <li><Link to="/contactus" activeClassName="active__link" onClick={() => setShowLinks(!showLinks)} > Contact Us</Link></li>

                    <li><Link className="cart__item" to="/cart" activeClassName="active__link" onClick={() => setShowLinks(!showLinks)}>
                        <FontAwesomeIcon
                            icon={faShoppingCart}
                        />
                        <span>{basket.length}</span>
                    </Link></li>

                </ul>
                <FontAwesomeIcon
                    onClick={() => setShowLinks(!showLinks)}
                    className="burger"
                    style={{ color: 'white' }}
                    icon={faBars}
                />
            </div>
        </nav>
    )
}

export default Nav
